import { Pipe, PipeTransform } from '@angular/core';
import { Terminal } from '@shared/classes/terminal';

@Pipe({
  name: 'terminalIdsTranslate',
  standalone: true
})
export class TerminalIdsTranslate implements PipeTransform {
  transform(value: number[], terminalList: Terminal[], maxCount?: number) {
    if (value && value.length > 0) {
      var endNumber = maxCount ? maxCount : 2;
      return value
        .map(item => terminalList.find(terminal => terminal.terminal_Id === item))
        .filter(item => item)
        .slice(0, endNumber)
        .map(item => item.terminalId)
        .join(',');
    }

    return '';
  }
}
